webpackJsonp([178813875387760],{

/***/ 1035:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0013_iron_man.jpg","type":"Unit","subtype":"Mercenary","cost":3,"ATK":3,"HP":4,"rules_text_1":null,"rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Iron Man","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"\"I'm Iron Man.\"","color":"Neutral","spec":"Bashing","bottom":"Tech I","rulings":[],"keywords":[],"slug":"iron_man"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"iron_man","keywords":[],"imageRegex":"/iron_man.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-iron-man-c6bd0701774abee93a7b.js